import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'

const FormSection = ({ children, title, icon, cols, className = "" }) => {
  const { t } = useTranslation()
  return (
    <section className={`form-section-item ${className}`}>
      {title && (
        <div className="section-title-wrapper">
          {icon && <Icon icon={icon} className="section-title-icon" />}
          <h3 className="section-title-text">{t(title)}</h3>
        </div>
      )}
      <div className={`section-grid grid-cols-${cols}`}>
        {children}
      </div>
    </section>
  )
}

export default FormSection